import React from 'react';
import './MemoryNumbersSupport.css';

const MemoryNumbersSupport = () => {
    return (
        <div className="support-container">
            <header className="header">
                <h1>Welcome to Recall Numbers | Brain Boost Support</h1>
                <p>Thank you for choosing Recall Numbers | Brain Boost! Find all the support and information you need to get the most out of our app.</p>
            </header>

            <section className="features">
                <h2>App Features</h2>
                <ul>
                    <li>Engaging memory challenges</li>
                    <li>Daily brain exercises</li>
                    <li>Progress tracking</li>
                    <li>Simple and addictive gameplay</li>
                </ul>
            </section>

            <section className="faq">
                <h2>Frequently Asked Questions</h2>
                <dl>
                    <dt>How do I use the app?</dt>
                    <dd>Explore the features and follow the in-app instructions.</dd>

                    <dt>What do I do if I encounter a problem?</dt>
                    <dd>Contact our support team for assistance.</dd>

                    <dt>How can I contact support?</dt>
                    <dd>Reach out via email or contact form below.</dd>
                </dl>
            </section>

            <section className="support">
                <h2>Contact Support</h2>
                <p>Need help? Reach out to our support team for assistance.</p>
                <p>Email: <a href="mailto:leblebiapps1@gmail.com">leblebiapps1@gmail.com</a></p>
                {/* <p>Contact Form: <a href="/contact-form">Submit a request</a></p> */}
                {/* <p>Social Media: <a href="https://twitter.com/example">Twitter</a> | <a href="https://facebook.com/example">Facebook</a></p> */}
            </section>

            <section className="feedback">
                <h2>Give Us Your Feedback</h2>
                <p>We value your feedback! Let us know how we can improve Recall Numbers | Brain Boost.</p>
                <p><a href="/feedback-form">Submit Feedback</a></p>
            </section>

            <section className="about">
                <h2>About Us</h2>
                <p>Learn more about the team behind Recall Numbers | Brain Boost and our mission to enhance cognitive skills.</p>
                <p><a href="/about">Read More</a></p>
            </section>

            <section className="legal">
                <h2>Legal Information</h2>
                <p>Read our privacy policy and terms of service.</p>
                <p><a href="/recall-numbers-privacy-policy">Privacy Policy</a> | <a href="/terms-of-service">Terms of Service</a></p>
            </section>
        </div>
    );
};

export default MemoryNumbersSupport;
